import { Box, Button, IconButton, Typography } from '@mui/material';
import { CloseIcon } from './CustomIcons';

interface TaskCompletedProps {
  title: string;
  description: string;
  buttonText: string;
  imgSrc: string;
  imgAlt?: string;
  imgWidth?: string;
  handleClick: () => void;
  handleClose: () => void;
}

const TaskCompleted = ({
  title,
  description,
  imgSrc,
  imgAlt,
  imgWidth,
  buttonText,
  handleClick,
  handleClose,
}: TaskCompletedProps) => {
  return (
    <Box
      sx={{ bgcolor: 'primary.main', pt: 8, px: 3, pb: 7.25 }}
      className="d-flex flex-column align-items-center flex-1"
    >
      <IconButton
        aria-label="back"
        sx={{ color: 'common.white', p: 0, mb: 6.75, alignSelf: 'end' }}
        onClick={handleClose}
      >
        <CloseIcon sx={{ fontSize: 40 }} />
      </IconButton>
      <Box mb={7} className="d-flex justify-content-center w-100">
        <img src={imgSrc} alt={imgAlt} width={imgWidth} />
      </Box>
      <Box mb={6.75}>
        <Typography
          variant="h4"
          color="common.white"
          mb={1.5}
          textAlign="center"
        >
          {title}
        </Typography>
        <Typography
          variant="subtitle2"
          sx={{ color: 'ghostWhite.main', textAlign: 'center' }}
        >
          {description}
        </Typography>
      </Box>
      <Button
        variant="contained"
        color="info"
        size="large"
        fullWidth
        sx={{ mt: 'auto' }}
        onClick={handleClick}
      >
        {buttonText}
      </Button>
    </Box>
  );
};

export default TaskCompleted;
